import { getEnvVariable } from '@/app/service/getenvService'

interface TncContent {
	tncVersion: string
	[key: string]: unknown
}

export const getTncContent = async (): Promise<TncContent> => {
	const tncBaseURL = await getEnvVariable('NEXT_PUBLIC_CDN_URL');
	const tncURL = `${tncBaseURL}/terms-and-conditions/tncContent.json`;
	const result = await fetch(tncURL, {
		cache: 'force-cache',
		next: { revalidate: 3600 } // Cache for one hour (3600 seconds)
	})
	.then((res) => {
		if (!res.ok) {
			throw new Error(`HTTP error! status: ${res.status}`)
		}
		return res.json();
	})
	return result.data;
}

export const getTncVersion = async (): Promise<string> => {
	const { tncVersion } = (await getTncContent()) as {
		tncVersion: string // e.g. '1.0.0'
	}
	return tncVersion
}
